import { render, staticRenderFns } from "./MarkdownEditor.vue?vue&type=template&id=c83c1d4a&"
import script from "./MarkdownEditor.js?vue&type=script&lang=js&"
export * from "./MarkdownEditor.js?vue&type=script&lang=js&"
import style0 from "./MarkdownEditor.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports